import { benefits } from "../constants";
import styles, { layout } from "../style";
// import Button from "./Button";

const FeatureCard = ({ icon, title, content, index }) => (
  <div
    className={`flex flex-row p-6 rounded-[20px] ${
      index !== benefits.length - 1 ? "mb-6" : "mb-0"
    } feature-card`}
  >
    <div
      className={`w-[64px] h-[64px] rounded-full ${styles.flexCenter} bg-dimBlue`}
    >
      <img src={icon} alt="icon" className="w-[50%] h-[50%] object-contain" />
    </div>
    <div className="flex-1 flex flex-col ml-3">
      <h4 className="font-poppins font-semibold text-white text-[18px] leading-[23px] mb-1">
        {title}
      </h4>
      <p className="font-poppins font-normal text-dimWhite text-[16px] leading-[24px] mb-1">
        {content}
      </p>
    </div>
  </div>
);

const Benefits = () => {
  return (
    <section id="benefits" className={layout.section}>
      <div className={layout.businessSectionInfo}>
        <h2 className={styles.heading2}>
          <span className="text-gradient"> Empower Your Home </span>
          <br className="sm:block hidden" />
          <span className="text-gradient"> with Starbridge! </span>
        </h2>
        <p className={`${styles.paragraph} max-w-[470px]`}>
          Whether upgrading or starting fresh, we simplify your selection
          process. Find the perfect doors and windows to customize your home for
          comfort, energy savings, and lasting style."
        </p>
        {/* <Button styles="mt-10" /> */}
      </div>

      <div className={`${layout.sectionImg} flex-col`}>
        {benefits.map((feature, index) => (
          <FeatureCard key={feature.id} {...feature} index={index} />
        ))}
      </div>
    </section>
  );
};

export default Benefits;
